/* Library */
import React, { Component } from 'react';
import _ from 'lodash';

import TextInput from '../../../../../components/ZUILib/TextInput';
import CalenderSample from '../../../../../components/ZUILib/CalenderSample';

import commonUtil from '../../../../../utils/commonUtil';
import CheckBox from '../../../../../components/ZUILib/CheckBox/CheckBox';
import { eventType, constChannel } from '../../../../../utils/clientConstant';
import { createTagsForInvalidFormControls } from '../../../../../utils/googleTagManagerUtils';

const errorObject = require('../../../../../utils/errors/LP_GR_error.json');

const channel = commonUtil.getChannel();

export default class EventCoOwnerType2 extends Component {
  constructor(props) {
    super(props);
    this.checkboxdetails = {
      emailDetail: '',
    };
    this.formData = {
      userData: {
        title: '',
        ownerLabel: '',
        profileId: '',
        firstName: '',
        lastName: '',
        nickName: '',
        phone: '',
        dateOfBirth: '',
        email: '',
        isMinor: '',
        is_coowner: '',
        sex: '',
        motherName: '',
      },
    };
    this.emailID = '';
    this.permitAccess = this.permitAccess.bind(this);
    this.isPermit = this.props.isPermit;
    this.hideCoOwnerForm = this.props.optional;
  }

  componentDidMount() { // To get user data on back fom 2nd step.
    if (this.emailID) {
      this.showEmailData.setChecked(true);
      this.permitAccess();
    }
    if (this.props.userData && this.props.userData.dateOfBirth) {
      this._CalenderSample.setDate(this.props.userData.dateOfBirth);
    }
  }

  // To get coOwner data on GiftRgistyClebated index page this getformData is using.
  getformData = () => this.formData.userData

  onPasteFunc = (e) => {
    const text = e.clipboardData.getData('Text');
    const numericValue = text ? text.replace(/\D/g, '') : '';
    if (text !== numericValue) {
      e.preventDefault();
    }
  }
  handleAllowOnlyDigit = (e) => {
    const keyCode = e.charCode;
    if (keyCode > 37 && (keyCode < 48 || keyCode > 57)) {
      e.preventDefault();
    }
  }

  handleformValidate = () => {  // For validation.
    const ownerEmailId = this.props.ownerEmailId ? this.props.ownerEmailId : null;
    let isFormValid = true;

    let firstNameValid = true;
    let lastNameValid = true;
    let emailValid = true;
    let birthDateValid = true;
    let maternalNameValid = true;
    let nickNameValid = true;
    let cellularValid = true;

    const firstNameValidationRules = [
      { functionRef: commonUtil.isValueAvailable, funcData: [this.txtFirstName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
      { functionRef: commonUtil.validateName, funcData: [this.txtFirstName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
    ];
    firstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.txtFirstName, null);

    const lastNameValidationRules = [
      { functionRef: commonUtil.isValueAvailable, funcData: [this.txtLastName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
      { functionRef: commonUtil.validateName, funcData: [this.txtLastName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
    ];
    lastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.txtLastName, null);

    const maternalNameValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.txtMotherName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.validateName, funcData: [this.txtMotherName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
    maternalNameValid = commonUtil.validateTextInput(maternalNameValidationRules, this.txtMotherName, null);

   
    const birthDateValidationRules = {
      functionRef: commonUtil.isValueAvailable, funcData: [this._CalenderSample.state.date], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required')
    };
    birthDateValid = commonUtil.validateCalendarInput(birthDateValidationRules, this._CalenderSample, null);
    

    if (this.props.eventName === eventType.XV_Anos) {
      if (this.isPermit) {
        const emailValidationRules = [
          { functionRef: commonUtil.compareEmail, funcData: [this.txtEmail.getValue(), ownerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error') },
          { functionRef: commonUtil.validateEmail, funcData: [this.txtEmail.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
        ];
        emailValid = commonUtil.validateTextInput(emailValidationRules, this.txtEmail, null);
      }
    }
    if (this.txtnickName.getValue()) {
      const nickNameValidationRules = [
        // { functionRef: commonUtil.validateLength, funcData: [this.txtnickName.getValue(), 1], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
        { functionRef: commonUtil.validateNameForAlphaNumeric, funcData: [this.txtnickName.getValue(), 1, false], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      nickNameValid = commonUtil.validateTextInput(nickNameValidationRules, this.txtnickName, null);
    }
    if (this.txtCellular.getValue()) {
      const CellularValidationRules = [
        { functionRef: commonUtil.validateNumber, funcData: [this.txtCellular.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      cellularValid = commonUtil.validateTextInput(CellularValidationRules, this.txtCellular, null);
    }

    isFormValid = (firstNameValid && lastNameValid && emailValid && birthDateValid && maternalNameValid && nickNameValid && cellularValid);

    if (isFormValid) {
      this.formData = {
        userData: {
          title: '',
          ownerLabel: this.props.eventDetail.labels[this.props.index],
          profileId: '',
          firstName: this.txtFirstName.getValue(),
          lastName: this.txtLastName.getValue(),
          motherName: this.txtMotherName.getValue(),
          nickName: this.txtnickName.getValue(),
          phone: this.txtCellular.getValue(),
          dateOfBirth: this._CalenderSample.state.date,
          isMinor: 'false',
          email: this.isPermit ? (this.txtEmail.getValue()).toLowerCase() : '',
          is_coowner: 'true',
          sex: '',
        },
      };
      return true;
    }

    const controls = [this.txtFirstName, this.txtLastName, this.txtMotherName, this._CalenderSample, this.txtEmail, this.txtnickName, this.txtCellular];
    const tagCompositor = c => ({
      event: 'alerta',
      phase: 'Crear mesa de regalos',
      step: 'Datos del festejado',
      color: 'Rojo',
      mensaje: 'Datos incompletos del festejado 2',
      mensaje_servicio: _.get(c, 'errorControl.innerText', 'undefined error'),
      seccion: 'Mesa de Regalos',
      tipo: 'formulario',
    });
    createTagsForInvalidFormControls({ controls, tagCompositor });

    if (!firstNameValid) {
      this.props.focusOnError('coOwner_firstname');
    } else if (!lastNameValid) {
      this.props.focusOnError('coOwner_lastname');
    } else if (!maternalNameValid) {
      this.props.focusOnError('coOwner_motherName');
    } else if (!nickNameValid) {
      this.props.focusOnError('coOwner_nickName');
    } else if (!birthDateValid) {
      this.props.focusOnError('calendar');
    } else if (!cellularValid) {
      this.props.focusOnError('phone');
    } else if (!emailValid) {
      this.props.focusOnError('coowner_email');
    }
    return false;
  }

  permitAccess() { // It is used to make permision checkbox checked.
    if (this.showEmailData.isChecked()) {
      this.isPermit = true;
      this.forCheck.style.display = 'block';
    } else {
      this.isPermit = false;
      this.forCheck.style.display = 'none';
    }
  }

  handlePopUpCoOwner = (id) => {
    if (channel === 'wap') {
      const data = document.querySelector('#' + id);
      if (data.style.display === 'block') {
        data.style.display = 'none';
      } else {
        data.style.display = 'block';
      }
    }
  }

  render() {
    const { eventDetail, userData, lables } = this.props;

    const textInputAttr = {
      textClassName: 'form-control',
      textLabelClassName: 'label_one',
      textHtmlId: 'calendar',
      textPlaceholder: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.dob.label'),
      textRequired: true,
    };
    this.emailID = (userData && userData.email) ? userData.email : '';

    return (
      <React.Fragment>
        <div className="formBlock">
          <h2 className="subtitleModule titleForm">{eventDetail.labels[this.props.index]}</h2>
        </div>
        <div className="formBlock">
          <TextInput
            doNotUpdateOnPropsChange="true"
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            htmlId="coOwner_firstname"
            label="Nombre"
            maxlength="100"
            required="true"
            star="*"
            value={userData ? userData.firstName : ''}
            ref={txtFirstName => this.txtFirstName = txtFirstName}
          />
        </div>
        <div className="formBlock">
          <TextInput
            doNotUpdateOnPropsChange="true"
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            htmlId="coOwner_lastname"
            label="Apellido Paterno"
            maxlength="100"
            required="true"
            value={userData ? userData.lastName : ''}
            star="*"

            ref={txtLastName => this.txtLastName = txtLastName}
          />
        </div>
        <div className="formBlock">
          <TextInput
            doNotUpdateOnPropsChange="true"
            className="inputMaterial"
            labelClassName="placeHolderMaterial"
            htmlId="coOwner_motherName"
            required="true"
            label="Apellido Materno"
            maxlength="100"
            star="*"
            value={userData ? userData.motherName : ''}
            ref={txtMotherName => this.txtMotherName = txtMotherName}
          />
        </div>
        <div className="formBlock">
          <div className="inLine input_help_icon">
            <TextInput
              doNotUpdateOnPropsChange="true"
              className="inputMaterial"
              htmlId="coOwner_nickName"
              labelClassName="placeHolderMaterial"
              label="Alias"
              required="false"
              maxlength="100"
              value={userData ? userData.nickName : ''}
              ref={txtnickName => this.txtnickName = txtnickName}
            />
          </div>
          <div className="iconHelp inLine"><i onClick={() => { this.handlePopUpCoOwner('helpPopupOne'); }} className="icon-ayuda" />
            <div id="helpPopupOne" className="popover bottom helpIconCss"><div className="arrow" />
              <div className="popover-content">
                <ul>
                  {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.alias.message')}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="formBlock">
          <div className="inputDate input-group date" id="datetimepicker2">
            <CalenderSample
              value={userData && userData.dateOfBirth ? userData.dateOfBirth : null}
              textInputJSON={textInputAttr}
              htmlId="calendar"
              minDate={this.props.startDate}
              maxDate={this.props.currentDate}
              activeStartDate={this.props.currentDate}
              viewType="decade"
              ref={(refd) => { this._CalenderSample = refd; }}
            />
          </div>
          <div className="formBlock">
            {channel === constChannel.WEB ?
              <TextInput
                doNotUpdateOnPropsChange="true"
                className="inputMaterial"
                labelClassName="placeHolderMaterial"
                htmlId="phone"
                label="Celular"
                required="false"
                maxlength="10"
                value={userData ? userData.phone : ''}
                onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }}
                onPaste={(e) => { this.onPasteFunc(e); }}
                ref={txtCellular => this.txtCellular = txtCellular}
              />
            :
              <TextInput
                doNotUpdateOnPropsChange="true"
                className="inputMaterial"
                labelClassName="placeHolderMaterial"
                htmlId="phone"
                label="Celular"
                type="tel"
                required="false"
                maxlength="10"
                value={userData ? userData.phone : ''}
                onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }}
                onPaste={(e) => { this.onPasteFunc(e); }}
                ref={txtCellular => this.txtCellular = txtCellular}
              />
          }
          </div>
          {this.props.eventName === eventType.XV_Anos ?
            // This condition is to check that if event is XV then show this chckbox either for all other religious typ event hide it.
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 moreOptions">
                <div className="formBlock">
                  <div className="inLine p-l-20">
                    <CheckBox htmlId={this.props.id + '_showEmail'} displayName={commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.permission.label')} ref={chk => this.showEmailData = chk} getSelectedValue={this.permitAccess} />
                  </div>
                  <div className="iconHelp inLine"><i onClick={() => { this.handlePopUpCoOwner('helpPopup'); }} className="icon-ayuda" />
                    <div id="helpPopup" className="popover bottom helpIconCssEmail"><div className="arrow" />
                      <div className="popover-content">
                        <ul dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.permissionAlias.message') }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 moreOptions permitAccess" style={{ display: 'none' }} ref={(forCheck) => { this.forCheck = forCheck; }}>
                <div className="formBlock">
                  <p className="descriptInfoAditional">{commonUtil.getLabel(lables.createEventStep1, 'eventCreation.stage1.permissionToCoowner.notify')}</p>
                </div>
                <div className="formBlock">
                  <TextInput
                    doNotUpdateOnPropsChange="true"
                    className="inputMaterial"
                    labelId="allowEmail-error"
                    labelClassName="placeHolderMaterial"
                    htmlId="coowner_email"
                    label={commonUtil.getLabel(lables.createLogin, 'create.account.email')}
                    required="true"
                    star="*"
                    maxlength="100"
                    value={this.emailID ? this.emailID : ''}
                    ref={txtEmail => this.txtEmail = txtEmail}
                  />
                </div>
              </div>
            </div>
            :
            null
          }
        </div>
      </React.Fragment>
    );
  }
}
